import { MaxUI, Panel } from '@maxhub/max-ui'
import '@maxhub/max-ui/dist/styles.css'
import type { ReactNode } from 'react'

type MaxShellProps = {
  children: ReactNode
}

export const MaxShell = ({ children }: MaxShellProps) => (
  <MaxUI>
    <Panel className="app-shell app-shell--max">{children}</Panel>
  </MaxUI>
)
